module.exports = __webpack_public_path__ + "img/P3.22ad008b.png";